// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/proposal_amendment.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * Issuance is independent of interpretation. These records are append-only.
 *
 * @generated from message mono.datagateway.v1.SolicitationVersion
 */ export class SolicitationVersion extends Message {
    static fromBinary(bytes, options) {
        return new SolicitationVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SolicitationVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SolicitationVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SolicitationVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string previous_id = 2;
   */ _define_property(this, "previousId", ""), /**
   * @generated from field: string attachment_id = 3;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string source_name = 4;
   */ _define_property(this, "sourceName", ""), /**
   * @generated from field: string source_hash = 5;
   */ _define_property(this, "sourceHash", ""), /**
   * @generated from field: string issued_by = 6;
   */ _define_property(this, "issuedBy", ""), /**
   * @generated from field: string issued_at = 7;
   */ _define_property(this, "issuedAt", ""), /**
   * @generated from field: string source_snapshot_json = 8;
   */ _define_property(this, "sourceSnapshotJson", ""), /**
   * @generated from field: int32 version_number = 9;
   */ _define_property(this, "versionNumber", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SolicitationVersion, "runtime", proto3);
_define_property(SolicitationVersion, "typeName", "mono.datagateway.v1.SolicitationVersion");
_define_property(SolicitationVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "previous_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_hash",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "issued_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "issued_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "version_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SolicitationImpact
 */ export class SolicitationImpact extends Message {
    static fromBinary(bytes, options) {
        return new SolicitationImpact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SolicitationImpact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SolicitationImpact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SolicitationImpact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * requirements, dates, instructions, templates
   *
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * added, changed, removed
   *
   * @generated from field: string change = 4;
   */ _define_property(this, "change", ""), /**
   * @generated from field: string before_text = 5;
   */ _define_property(this, "beforeText", ""), /**
   * @generated from field: string current_text = 6;
   */ _define_property(this, "currentText", ""), /**
   * @generated from field: string source_locator = 7;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string rationale = 8;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: repeated string affected_review_ids = 9;
   */ _define_property(this, "affectedReviewIds", []), /**
   * @generated from field: string recorded_by = 10;
   */ _define_property(this, "recordedBy", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalMaterialAssessment material_assessments = 11;
   */ _define_property(this, "materialAssessments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SolicitationImpact, "runtime", proto3);
_define_property(SolicitationImpact, "typeName", "mono.datagateway.v1.SolicitationImpact");
_define_property(SolicitationImpact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "change",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "before_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "current_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "affected_review_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "material_assessments",
            kind: "message",
            T: ProposalMaterialAssessment,
            repeated: true
        }
    ]));
/**
 * Explicit human interpretation for a stored material, even without a review.
 *
 * @generated from message mono.datagateway.v1.ProposalMaterialAssessment
 */ export class ProposalMaterialAssessment extends Message {
    static fromBinary(bytes, options) {
        return new ProposalMaterialAssessment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalMaterialAssessment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalMaterialAssessment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalMaterialAssessment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string material_kind = 1;
   */ _define_property(this, "materialKind", ""), /**
   * @generated from field: string material_id = 2;
   */ _define_property(this, "materialId", ""), /**
   * @generated from field: bool affected = 3;
   */ _define_property(this, "affected", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalMaterialAssessment, "runtime", proto3);
_define_property(ProposalMaterialAssessment, "typeName", "mono.datagateway.v1.ProposalMaterialAssessment");
_define_property(ProposalMaterialAssessment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "material_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "affected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalReviewSnapshot
 */ export class ProposalReviewSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new ProposalReviewSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalReviewSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalReviewSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalReviewSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * section, staffing, pricing, attachment
   *
   * @generated from field: string material_kind = 3;
   */ _define_property(this, "materialKind", ""), /**
   * @generated from field: string material_id = 4;
   */ _define_property(this, "materialId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string content_snapshot_json = 6;
   */ _define_property(this, "contentSnapshotJson", ""), /**
   * @generated from field: string content_hash = 7;
   */ _define_property(this, "contentHash", ""), /**
   * @generated from field: string reviewed_by = 8;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: string reviewed_at = 9;
   */ _define_property(this, "reviewedAt", ""), /**
   * @generated from field: bool needs_review = 10;
   */ _define_property(this, "needsReview", false), /**
   * @generated from field: repeated string stale_reasons = 11;
   */ _define_property(this, "staleReasons", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalReviewSnapshot, "runtime", proto3);
_define_property(ProposalReviewSnapshot, "typeName", "mono.datagateway.v1.ProposalReviewSnapshot");
_define_property(ProposalReviewSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "material_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "content_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "content_hash",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reviewed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "needs_review",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "stale_reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalReviewMaterial
 */ export class ProposalReviewMaterial extends Message {
    static fromBinary(bytes, options) {
        return new ProposalReviewMaterial().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalReviewMaterial().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalReviewMaterial().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalReviewMaterial, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalReviewMaterial, "runtime", proto3);
_define_property(ProposalReviewMaterial, "typeName", "mono.datagateway.v1.ProposalReviewMaterial");
_define_property(ProposalReviewMaterial, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SolicitationReviewState
 */ export class SolicitationReviewState extends Message {
    static fromBinary(bytes, options) {
        return new SolicitationReviewState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SolicitationReviewState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SolicitationReviewState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SolicitationReviewState, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SolicitationVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * @generated from field: repeated mono.datagateway.v1.SolicitationImpact impacts = 2;
   */ _define_property(this, "impacts", []), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalReviewSnapshot reviews = 3;
   */ _define_property(this, "reviews", []), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalReviewMaterial available_materials = 4;
   */ _define_property(this, "availableMaterials", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SolicitationReviewState, "runtime", proto3);
_define_property(SolicitationReviewState, "typeName", "mono.datagateway.v1.SolicitationReviewState");
_define_property(SolicitationReviewState, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: SolicitationVersion,
            repeated: true
        },
        {
            no: 2,
            name: "impacts",
            kind: "message",
            T: SolicitationImpact,
            repeated: true
        },
        {
            no: 3,
            name: "reviews",
            kind: "message",
            T: ProposalReviewSnapshot,
            repeated: true
        },
        {
            no: 4,
            name: "available_materials",
            kind: "message",
            T: ProposalReviewMaterial,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReadSolicitationReviewRequest
 */ export class ReadSolicitationReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReadSolicitationReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadSolicitationReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadSolicitationReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadSolicitationReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadSolicitationReviewRequest, "runtime", proto3);
_define_property(ReadSolicitationReviewRequest, "typeName", "mono.datagateway.v1.ReadSolicitationReviewRequest");
_define_property(ReadSolicitationReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReadSolicitationReviewResponse
 */ export class ReadSolicitationReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReadSolicitationReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadSolicitationReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadSolicitationReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadSolicitationReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SolicitationReviewState state = 1;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadSolicitationReviewResponse, "runtime", proto3);
_define_property(ReadSolicitationReviewResponse, "typeName", "mono.datagateway.v1.ReadSolicitationReviewResponse");
_define_property(ReadSolicitationReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "message",
            T: SolicitationReviewState
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IssueSolicitationVersionRequest
 */ export class IssueSolicitationVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new IssueSolicitationVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueSolicitationVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueSolicitationVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueSolicitationVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string attachment_id = 3;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueSolicitationVersionRequest, "runtime", proto3);
_define_property(IssueSolicitationVersionRequest, "typeName", "mono.datagateway.v1.IssueSolicitationVersionRequest");
_define_property(IssueSolicitationVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IssueSolicitationVersionResponse
 */ export class IssueSolicitationVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new IssueSolicitationVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueSolicitationVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueSolicitationVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueSolicitationVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SolicitationVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueSolicitationVersionResponse, "runtime", proto3);
_define_property(IssueSolicitationVersionResponse, "typeName", "mono.datagateway.v1.IssueSolicitationVersionResponse");
_define_property(IssueSolicitationVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: SolicitationVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordSolicitationImpactRequest
 */ export class RecordSolicitationImpactRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordSolicitationImpactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordSolicitationImpactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordSolicitationImpactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordSolicitationImpactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.datagateway.v1.SolicitationImpact impact = 3;
   */ _define_property(this, "impact", void 0), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordSolicitationImpactRequest, "runtime", proto3);
_define_property(RecordSolicitationImpactRequest, "typeName", "mono.datagateway.v1.RecordSolicitationImpactRequest");
_define_property(RecordSolicitationImpactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "impact",
            kind: "message",
            T: SolicitationImpact
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordSolicitationImpactResponse
 */ export class RecordSolicitationImpactResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordSolicitationImpactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordSolicitationImpactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordSolicitationImpactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordSolicitationImpactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SolicitationImpact impact = 1;
   */ _define_property(this, "impact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordSolicitationImpactResponse, "runtime", proto3);
_define_property(RecordSolicitationImpactResponse, "typeName", "mono.datagateway.v1.RecordSolicitationImpactResponse");
_define_property(RecordSolicitationImpactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "impact",
            kind: "message",
            T: SolicitationImpact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureProposalReviewRequest
 */ export class CaptureProposalReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProposalReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProposalReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProposalReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProposalReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string material_kind = 4;
   */ _define_property(this, "materialKind", ""), /**
   * @generated from field: string material_id = 5;
   */ _define_property(this, "materialId", ""), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProposalReviewRequest, "runtime", proto3);
_define_property(CaptureProposalReviewRequest, "typeName", "mono.datagateway.v1.CaptureProposalReviewRequest");
_define_property(CaptureProposalReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "material_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureProposalReviewResponse
 */ export class CaptureProposalReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProposalReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProposalReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProposalReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProposalReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalReviewSnapshot review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProposalReviewResponse, "runtime", proto3);
_define_property(CaptureProposalReviewResponse, "typeName", "mono.datagateway.v1.CaptureProposalReviewResponse");
_define_property(CaptureProposalReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalReviewSnapshot
        }
    ]));
